
import { NgModule }      from '@angular/core';
import { CustomNumberPipe } from './customNumber.pipe';
import { CustomNumberWithInvPipe } from './customNumberWithInv.pipe';

@NgModule({
    imports:        [],
    declarations:   [CustomNumberPipe, CustomNumberWithInvPipe],
    exports:        [CustomNumberPipe, CustomNumberWithInvPipe],
})
export class CustomPipesModule {
  static forRoot() {
     return {
         ngModule: CustomPipesModule,
         providers: [],
     };
  }
}